module.exports = __webpack_public_path__ + "media/application/images/svgs/chevrons-up-9c95e1b025d12fdac6f7f78a2202dbd4.svg";